import { InvoiceWithItemsRequest, InvoiceToCustomerRequest, Invoice, ItemizedInvoice, InvoiceProjectCustomer, CreateItemizedInvoiceRequest, InvoiceTotals, GetItemizedInvoicesResponse, ItemizedInvoiceTotals } from './invoiceType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class invoiceApi {

    static async sendInvoiceToCustomer(invoiceToCustomerRequest: InvoiceToCustomerRequest) {
        try {
            const response = await fetch(`${API_BASE_URL}/invoices/send_invoice`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(invoiceToCustomerRequest), // Remove the extra object wrapper {payload}
                credentials: 'include', // Include cookies in the request
            });

            if (response.ok) {

            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                // Handle error response
                const errorBody = await response.text();
                let errorMessage = `Error ${response.status}: ${response.statusText}`;
                if (errorBody) {
                    errorMessage += ` - ${errorBody}`;
                }
                throw new Error(errorMessage);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to send invoice: ${error.message}`);
            } else {
                throw new Error('Failed to sebd invoice: An unknown error occurred.');
            }
        }
    }

    static async getInvoicesProjectsCustomers(invoiceId?: string | number): Promise<InvoiceProjectCustomer[]> {
        try {
            // Build URL with optional invoice_id parameter
            let url = `${API_BASE_URL}/invoices/invoices_projects_customers`;
            if (invoiceId) {
                url += `?invoice_id=${invoiceId}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                const invoices: InvoiceProjectCustomer[] = responseBody.data.map((item: any) => {
                    return {
                        invoice_id: item.attributes.invoice_id,
                        name: item.attributes.name,
                        payment_instruction: item.attributes.payment_instruction,
                        tax_rate: item.attributes.tax_rate,
                        discount_usd: item.attributes.discount_usd,
                        amount_paid: item.attributes.amount_paid,
                        issue_date: item.attributes.issue_date,
                        due_date: item.attributes.due_date,
                        sub_total_sum_lineitems: item.attributes.sub_total_sum_lineitems,
                        sub_total_after_tax: item.attributes.sub_total_after_tax,
                        tax_amount: item.attributes.tax_amount,
                        final_total: item.attributes.final_total,
                        project_id: item.attributes.project_id,
                        project_name: item.attributes.project_name,
                        project_description: item.attributes.project_description,
                        project_type: item.attributes.project_type,
                        customer_id: item.attributes.customer_id,
                        customer_first_name: item.attributes.customer_first_name,
                        customer_last_name: item.attributes.customer_last_name,
                        customer_address_1: item.attributes.customer_address_1,
                        customer_address_2: item.attributes.customer_address_2, // Added this field
                        customer_city: item.attributes.customer_city,
                        customer_state: item.attributes.customer_state,
                        customer_zip: item.attributes.customer_zip,
                        customer_phone: item.attributes.customer_phone,
                        customer_email: item.attributes.customer_email,
                    };
                });
                return invoices;
            }
            else if (response.status === 404) {
                return [];
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                const errorMessage = invoiceId
                    ? `Failed to get invoice ${invoiceId}: ${error.message}`
                    : `Failed to get invoice-project: ${error.message}`;
                throw new Error(errorMessage);
            } else {
                const errorMessage = invoiceId
                    ? `Failed to get invoice ${invoiceId}: An unknown error occurred.`
                    : 'Failed to get invoice-project: An unknown error occurred.';
                throw new Error(errorMessage);
            }
        }
    }


    static async createInvoice(invoice: InvoiceWithItemsRequest) {

        try {
            const response = await fetch(`${API_BASE_URL}/invoices`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },

                body: JSON.stringify({ invoice }),
                credentials: 'include', // Include cookies in the request
            });

            //const headers: { [key: string]: string } = {};
            //response.headers.forEach((value, key) => { headers[key] = value; });
            const responseBody = await response.json();
            if (response.status === 201) {
                return responseBody
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(`${responseBody.error}, status: ${response.status}`);
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create invoice: ${error.message}`);
            } else {
                throw new Error('Failed to create invoice: An unknown error occurred.');
            }
        }
    }

    static async createItemizedInvoice(itemizedInvoice: CreateItemizedInvoiceRequest[]) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_invoices`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ itemized_invoice: { itemizedInvoice } }),

                credentials: 'include',
            });
            const responseBody = await response.json();
            if (response.status === 201) {
                return responseBody;

            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(response.statusText);
                }
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create itemized invoice: ${error.message}`);
            } else {
                throw new Error('Failed to create itemized invoice: An unknown error occurred.');
            }
        }
    }

    //static async updateItemizedinvoice(itemizeinvoiceId: string, itemized_invoice: Itemizedinvoice) {
    static async updateItemizedInvoice(itemizeInvoiceId: string, itemized_invoice: ItemizedInvoice) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_invoices/${itemizeInvoiceId}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ itemizedInvoice: itemized_invoice }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update itemized invoice: ${error.message}`);
            } else {
                throw new Error('Failed to update itemized invoice: An unknown error occurred.');
            }
        }
    }


    static async getItemizedInvoices(id: string): Promise<GetItemizedInvoicesResponse> {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_invoices/by_invoice?invoice_id=${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });
            const responseBody = await response.json();

            if (response.status === 200) {
                const itemizedInvoices: ItemizedInvoice[] = responseBody.data.data.map((item: any) => {
                    return {
                        itemized_invoice_id: item.attributes.itemized_invoice_id,
                        invoice_id: item.attributes.invoice_id,
                        code: item.attributes.code,
                        description: item.attributes.description,
                        amount_dollar: item.attributes.amount_dollar,
                    };
                });

                // Extract totals from the new response structure
                const totals: ItemizedInvoiceTotals = {
                    sub_total: Number(responseBody.totals?.sub_total || 0),
                    tax_rate: Number(responseBody.totals?.tax_rate || 0),
                    tax_amount: Number(responseBody.totals?.tax_amount || 0),
                    discount_usd: Number(responseBody.totals?.discount_usd || 0),
                    amount_paid: Number(responseBody.totals?.amount_paid || 0),
                    balance: Number(responseBody.totals?.balance || 0),
                };

                return { itemizedInvoices, totals };
            }
            else if (response.status === 404) {
                return {
                    itemizedInvoices: [],
                    totals: {
                        sub_total: 0,
                        tax_rate: 0,
                        tax_amount: 0,
                        discount_usd: 0,
                        amount_paid: 0,
                        balance: 0,
                    }
                };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get itemized invoice: ${error.message}`);
            } else {
                throw new Error('Failed to get itemized invoice: An unknown error occurred.');
            }
        }
    }



    static async viewInvoicePdf(id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/invoices/pdf?invoice_id=${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });


            if (response.ok) {
                // Return the PDF blob directly
                const blob = await response.blob();
                return blob;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                const errorBody = await response.text();
                let errorMessage = `Error ${response.status}: ${response.statusText}`;
                if (errorBody) {
                    errorMessage += ` - ${errorBody}`;
                }
                throw new Error(errorMessage);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to view invoice in pdf: ${error.message}`);
            } else {
                throw new Error('Failed to view invoice in pdf: An unknown error occurred.');
            }
        }
    }

    static async getInvoiceById(id: string): Promise<{
        invoice: Invoice;
        itemizedInvoices: ItemizedInvoice[];
        totals: ItemizedInvoiceTotals;
    }> {
        try {
            const response = await fetch(`${API_BASE_URL}/invoices/${id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                // Parse invoice data
                const invoiceData = responseBody.invoice.data.attributes;

                // Extract payment information from payments array (use first payment if exists)
                const payment = responseBody.payments && responseBody.payments.length > 0
                    ? responseBody.payments[0]
                    : null;

                const invoice: Invoice = {
                    invoice_id: invoiceData.invoice_id,
                    name: invoiceData.name,
                    payment_instruction: invoiceData.payment_instruction,
                    tax_rate: invoiceData.tax_rate,
                    amount_paid: payment ? parseFloat(payment.amount) : parseFloat(invoiceData.amount_paid || '0'),
                    discount_usd: invoiceData.discount_usd,
                    sub_total_sum_lineitems: invoiceData.sub_total_sum_lineitems,
                    sub_total_after_tax: invoiceData.sub_total_after_tax,
                    tax_amount: invoiceData.tax_amount,
                    final_total: invoiceData.final_total,
                    issue_date: invoiceData.issue_date,
                    due_date: invoiceData.due_date,
                    project_id: invoiceData.project_id,
                    customer_id: invoiceData.customer_id,
                    // Add payment fields from payments array
                    payment_method: payment?.payment_method || '',
                    payment_date: payment?.payment_date || '',
                    note: payment?.note || '',
                };

                // Parse line items data
                const itemizedInvoices: ItemizedInvoice[] = responseBody.line_items.data.map((item: any) => {
                    return {
                        itemized_invoice_id: item.attributes.itemized_invoice_id,
                        invoice_id: item.attributes.invoice_id,
                        code: item.attributes.code,
                        description: item.attributes.description,
                        amount_dollar: parseFloat(item.attributes.amount_dollar),
                    };
                });

                // Parse totals data
                const totals: ItemizedInvoiceTotals = {
                    sub_total: parseFloat(responseBody.totals.sub_total),
                    tax_rate: responseBody.totals.tax_rate,
                    tax_amount: responseBody.totals.tax_amount,
                    discount_usd: responseBody.totals.discount_usd,
                    amount_paid: responseBody.totals.amount_paid,
                    balance: responseBody.totals.balance,
                };

                return { invoice, itemizedInvoices, totals };
            } else if (response.status === 404) {
                throw new Error('Invoice not found');
            } else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            } else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get invoice: ${error.message}`);
            } else {
                throw new Error('Failed to get invoice: An unknown error occurred.');
            }
        }
    }


    static async updateInvoice(invoiceId: string, invoice: Invoice) {
        try {
            const response = await fetch(`${API_BASE_URL}/invoices/${invoiceId}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ invoice: invoice }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {

            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);

                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update invoice: ${error.message}`);
            } else {
                throw new Error('Failed to update invoice: An unknown error occurred.');
            };
        }
    }

    static async updateInvoiceAndLineitems(
        invoiceId: string,
        invoiceData: Partial<Invoice>,
        lineItems: Array<{
            id?: number;
            code: string;
            description: string;
            amount_dollar: number;
        }>
    ) {
        try {
            const response = await fetch(`${API_BASE_URL}/invoices/${invoiceId}/update_with_lineitems`, {
                method: 'PATCH',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    invoice: invoiceData,
                    lineItems: lineItems
                }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                return responseBody;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update invoice with line items: ${error.message}`);
            } else {
                throw new Error('Failed to update invoice with line items: An unknown error occurred.');
            }
        }
    }

    static async deleteInvoice(invoice_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/invoices/${invoice_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete invoice: ${error.message}`);
            } else {
                throw new Error('Failed to delete invoice: An unknown error occurred.');
            }
        }
    }

    static async deleteAllItemizedInvoice(invoice_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_invoices/invoices/${invoice_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete itemized invoice: ${error.message}`);
            } else {
                throw new Error('Failed to delete itemized invoice: An unknown error occurred.');
            }
        }
    }


    static async deleteItemizedInvoice(itemizedInvoice_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/itemized_invoices/${itemizedInvoice_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete itemized invoice: ${error.message}`);
            } else {
                throw new Error('Failed to delete itemized invoice: An unknown error occurred.');
            }
        }
    }
}

export default invoiceApi;